import React, { useState } from 'react';
import Link from './link';
import { NavLink } from 'react-router-dom';

const HamburgerMenu = () => {
    const [isNavOpen, setIsNavOpen] = useState(false); // initiate isNavOpen state with false

    const handleClick = (event) => {
        event.preventDefault();
        setIsNavOpen(false)
        const targetElement = document.querySelector('#section1');
        if (targetElement) {
            window.scrollTo({
                top: targetElement.offsetTop - 128,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className="flex items-center justify-between">
            <nav>
                <section className="MOBILE-MENU flex lg:hidden">
                    <div
                        className="space-y-2"
                        onClick={() => setIsNavOpen((prev) => !prev)}
                    >
                        <span className="block h-0.5 w-8 animate-pulse bg-blue"></span>
                        <span className="block h-0.5 w-8 animate-pulse bg-blue"></span>
                        <span className="block h-0.5 w-8 animate-pulse bg-blue"></span>
                    </div>
                    {isNavOpen && (
                        <div
                            className="fixed inset-0 z-40 bg-darkblue/50"
                            onClick={() => setIsNavOpen(false)}
                        ></div>
                    )}
                    <div className={isNavOpen ? "flex flex-row justify-start fixed left-0 top-0 w-4/5 max-w-xs h-screen z-50 bg-white shadow-xl overflow-y-auto" : "hidden"}>
                        <div className="absolute top-0 right-0 px-6 py-6" onClick={() => setIsNavOpen(false)}>
                            <svg className="h-8 w-8 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18" />
                                <line x1="6" y1="6" x2="18" y2="18" />
                            </svg>
                        </div>
                        <div className="MENU-LINK-MOBILE-OPEN flex flex-col items-start justify-start gap-8 p-12 pt-24 w-full text-lg">
                            <Link href='#section1' setIsNavOpen={setIsNavOpen}>Home</Link>
                            <Link href='#section2' setIsNavOpen={setIsNavOpen}>What we do</Link>
                            <Link href='#section25' setIsNavOpen={setIsNavOpen}>Services</Link>
                            <Link href='#section3' setIsNavOpen={setIsNavOpen}>How it works</Link>
                            <Link href='#section4' setIsNavOpen={setIsNavOpen}>Pricing</Link>
                            <NavLink to='/blog' onClick={() => setIsNavOpen(false)}>Blog</NavLink>
                            <NavLink to='/locations' onClick={() => setIsNavOpen(false)}>Locations</NavLink>
                        </div>
                    </div>
                </section>
            </nav>
        </div>
    );
};

export default HamburgerMenu;
